export const requestInvoiceData = [
  {
    Question: `How do I connect with you quickly to request an Invoice?`,
    Answer: `Need a quick way to view your invoice when you can't find your Customer ID? Connect with us quickly:  

        <ul><li>For residential customers, please <a href=’https://www.wm.com/us/en/support#support’>Contact Us.</a></li> 
        
        <li>For commercial customers, please <a href=’https://www.wm.com/us/en/support#support’>Contact Us.</a></li></ul>`,
  },
]
